import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackNext.svg",
  "use": "PlaybackNext.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackNext.svg\"><path d=\"M12.9987,19.3057,29.9973,29.6226V21.0994a1.9967,1.9967,0,0,1,3.0014-1.7937L50.01,29.63v-8.61a2,2,0,0,1,4,0v22a2,2,0,0,1-4,0V34.4094L32.9987,44.7341A1.9968,1.9968,0,0,1,29.9973,42.94V34.4174L12.9987,44.7341A1.9967,1.9967,0,0,1,9.9973,42.94V21.0994A1.9967,1.9967,0,0,1,12.9987,19.3057Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol